import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EditCategory from 'components/onboarding/EditCategory.component';
import LINK from 'constants/link.const';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToSpacelessString from 'utils/converters/fromAnyToSpacelessString.util';
import { fromPropsToQuery, fromPropsToQueryString } from 'utils/converters/props/path.util';
import navFor from 'utils/links/navFor.util';
import asObject from 'utils/objects/asObject.util';
import categoryExists from 'utils/salons/categoryExists.util';

import PopupModalContainer from 'common/PopupModal';
import HeaderContainer from 'onboarding/common/Header';
import OnboardingFooter from 'onboarding/common/OnboardingFooter';
import { addCategory, clearServicesState, editCategory } from 'onboarding/services/actions';

class EditCategoryWrap extends React.Component {
  constructor(props) {
    super(props);

    let selectedCategory = {
      color: '#3DA49D',
      name: '',
      services: [],
    };

    let isFooterButtonActive = false;
    if (props.location && props.location.state && props.location.state.category) {
      selectedCategory = props.location.state.category;
      isFooterButtonActive = true;
    }

    this.state = {
      isFooterButtonActive,
      category: selectedCategory,
      errorMessage: '',
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.currentSalon || !this.state.category) {
      navFor('EditCategoryWrap.componentWillMount()', this.props).push({
        pathname: LINK.onboardingType,
        search: fromPropsToQueryString(this.props),
      });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isSaved) {
      this.props.clearServicesState();
      navFor('AddStylistWrap.componentWillReceiveProps()', this.props).push({
        pathname: LINK.onboardingCategories,
        search: fromPropsToQueryString(this.props),
      });
    }
  }

  onFooterButtonClicked = () => {
    const { addCategorgy, editCategory, categories, currentSalon, location } = this.props;
    const { category, isFooterButtonActive } = this.state;

    if (!isFooterButtonActive) {
      return;
    }

    if (categoryExists({ categories, category })) {
      this.setState({ errorMessage: 'A category with that name already exists!' });
      return;
    }

    const salonId = asObject(currentSalon).id || fromPropsToQuery(this.props).salonId;

    if (asObject(location).state) {
      editCategory(category, salonId);
    } else {
      addCategorgy(category, salonId);
    }
  };

  changeCategoryName = (name) => {
    const category = Object.assign({}, this.state.category);
    category.name = name;
    this.setState({ category }, () => void this.checkButton());
  };

  changeCategoryColor = (color) => {
    const category = Object.assign({}, this.state.category);
    category.color = color;
    this.setState({ category });
  };

  checkButton = () =>
    void this.setState({ isFooterButtonActive: fromAnyToBool(fromAnyToSpacelessString(this.state.category.name)) });

  hideError = () => void this.setState({ errorMessage: '' });

  render() {
    const { isFetching, location, isPosting } = this.props;

    const title = location.state ? 'Edit Category' : 'Create a New Category';

    return (
      <div data-bem="EditCategoryWrap" className="content-wrap">
        {this.state.errorMessage && (
          <PopupModalContainer
            popupTitle="Error"
            popupMessage={this.state.errorMessage}
            buttonText="Okay"
            buttonCallback={this.hideError}
          />
        )}
        <HeaderContainer titleFirstPart={title} description="Enter a name for your category and select a colour" />
        <EditCategory
          category={this.state.category}
          changeCategoryName={this.changeCategoryName}
          changeCategoryColor={this.changeCategoryColor}
        />
        <OnboardingFooter
          isFooterButtonActive={this.state.isFooterButtonActive}
          onButtonClick={this.onFooterButtonClicked}
          isLoading={isFetching || isPosting}
        />
        {(isPosting || isFetching) && <div data-bem="EditCategoryWrap__load-blocker" className="load-blocker" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isFetching: state?.onboarding?.services?.isFetching,
  isPosting: state?.onboarding?.services?.isPosting,
  isSaved: state?.onboarding?.services?.isSaved,
  currentSalon: state?.currentSalon,
  categories: state?.onboarding?.services?.categories,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      editCategory,
      addCategorgy: (category, salonId) => addCategory(category.name, category.color, salonId),
      clearServicesState,
    },
    dispatch,
  );

const EditCategoryWrapHoc = connect(mapStateToProps, mapDispatchToProps)(EditCategoryWrap);

export default EditCategoryWrapHoc;
